import qcFinished from 'redux/actions/global/qcFinished';
export {
// eslint-disable-next-line import/prefer-default-export
qcFinished };